import { DailyReportSection, MonthlyReportSection } from "@/components/accounting/ReportSections";

export default function ReportsTab() {
  return (
    <div className="space-y-6" data-testid="reports-tab">
      <DailyReportSection />
      <MonthlyReportSection />
    </div>
  );
}
